import PropTypes from 'prop-types';

import './SimpleTextarea.css';

import { buildClass } from '../../libs/classes';

/**
 * Simple textarea component
 * @component
 */
export const SimpleTextarea = ({ placeholder, value, title, className, onChange, onKeyDown, tabIndex, limit }) => {
	return (
		<div className={buildClass('simple-textarea', className).add(limit, 'limited')}>
			<textarea
				placeholder={placeholder}
				tabIndex={tabIndex}
				title={title}
				value={value}
				onChange={onChange}
				onKeyDown={onKeyDown}
			/>
			{limit > 0 ? (
				<label className="limit" title="Max length">
					{value.length}&thinsp;/&thinsp;{limit}
				</label>
			) : null}
		</div>
	);
};

SimpleTextarea.propTypes = {
	// Placeholder for unfocused & empty input
	placeholder: PropTypes.string,
	// Value of input
	value: PropTypes.string.isRequired,
	// Title html attribute for component
	title: PropTypes.string,
	// Custom class
	className: PropTypes.string,
	// Callback function on change
	onChange: PropTypes.func.isRequired,
	// Callback function key down
	onKeyDown: PropTypes.func,
	// Custom tab order of an element
	tabIndex: PropTypes.number,
	// Length limit
	limit: PropTypes.number,
};

export default SimpleTextarea;
